
import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import hcdComponent from '@/web/components/index.js'
import './assets/css/common.less'
import Element from 'element-ui'
// import element from '@/web/utils/element'
import axios from 'axios'
axios.defaults.baseURL = '/loan/api/v1'

axios.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('token')
  if (token) {
    config.headers.accessToken = token
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(res => {
  if (res?.data?.code > 200 && res?.data?.message) {
    if (res?.data?.code === 401) {
      router.push('/login')
      // window.location.href = '#/login'
    } else {
      window.global.$message.error('' + res?.data?.message)
      return Promise.reject(new Error('' + res?.data?.message))
    }
  } else {
    return Promise.resolve(res)
  }
})

Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(Element, { size: 'small' })
Vue.use(hcdComponent)
Vue.mixin({
  methods: {
    getPermissionList () {
      // 尝试两种可能的键名
      let permission = localStorage.getItem('permissions') || localStorage.getItem('permission') || '[]'
      try {
        return JSON.parse(permission)
      } catch (e) {
        console.error('解析权限数据失败:', e)
        return []
      }
    },
    hasPermission (code) {
      const permission = this.getPermissionList()
      // 检查是否为超级管理员
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      const isAdmin = userInfo.roleCode === 'SUPER_ADMIN' || userInfo.username === 'admin' || permission.includes('*:*:*')
      
      console.log(`权限检查: ${code}`, {
        用户信息: userInfo,
        是否管理员: isAdmin,
        权限列表: permission,
        检查结果: isAdmin || permission.includes(code)
      })
      
      if (isAdmin) {
        return true
      }
      return permission.includes(code)
    },
    isAdmin() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      const permission = this.getPermissionList()
      return userInfo.roleCode === 'SUPER_ADMIN' || userInfo.username === 'admin' || permission.includes('*:*:*')
    }
  }
})

window.global = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
